// FileTypeSelector.jsx
import { DropDownList } from "@progress/kendo-react-dropdowns";

export default function FileTypeSelector({ options = [], value, onChange, disabled }) {
    // Normalize options for display, but keep 'type' as the key
    const data = options.map(o => ({
        ...o,
        text: o.confidence != null
            ? `${o.type} (${Math.round((o.confidence || 0) * 100)}%)`
            : o.type,
    }));

    const current = data.find(d => d.type === value) || null;

    return (
        <DropDownList
            data={data}
            textField="text"
            dataItemKey="type"
            value={current}
            onChange={(e) => onChange?.(e.value?.type ?? null)}  // <-- pass ONLY the .type string up
            disabled={disabled}
            defaultItem={{
                text: "No file type detected yet",
                value: null
            }}
        />
    );
}
